<template>
  <div class="chart-registrations-by-years">
    <div class="thumbnail" style="margin-bottom: 0">
      <loading v-if="!chartOptions"/>
      <highcharts v-else :options="chartOptions" ref="highcharts"></highcharts>
    </div>
  </div>
</template>

<script>
  import * as config from '../../config.js'
  import {mapState, mapActions} from 'vuex'
  // import _ from 'lodash'

  export default{
    name: 'ChartRegistrationsByYears',
    components: {},
    data () {
      return {
        chartOptions: false
      }
    },
    computed: {
      apiDomain () {
        return config.apiDomain
      },
      ...mapState({
        user: state => state.user
      })
    },
    mounted () {
      this.getRegistrationsByYears()
    },
    methods: {
      getRegistrationsByYears () {
        this.loadRegistrationsByYears({ companyId: this.user.company.id })
        .then((response) => {
          this.chartOptions = {
            chart: {
              height: 300,
              displayErrors: true
            },
            title: {
              text: 'Cadastros que foram realizados no mês'
            },
            subtitle: {
              // text: 'Comparativo: Ano anterior X Ano atual'
              text: 'Ano ' + response.data.year
            },
            xAxis: {
              categories: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
              crosshair: true
            },
            yAxis: {
              min: 0,
              title: {
                text: 'Quantidade de cadastros'
              }
            },
            tooltip: {
              /*
              formatter: function () {
                let str = '<div style="text-align: center; font-size: 12px; padding-bottom: 5px;"><b>' + this.x + '</b></div>'
                str += '<table border="1" width="100%" style="text-align: center;">'
                str += '<tr><td colspan="2"><b>TOTAL</b></td></tr>'

                let strCurrent = '<tr>'
                let strBefore = '<tr>'
                _.each(this.points, (p) => {
                  if (p.series.type === 'line') {
                    if (p.series.name === 'atual') {
                      strCurrent += '<td style="padding:0 3px; color:' + p.series.color + ';"><b>Ano ' + p.series.name + '</b></td>'
                      str += '<tr style="color:' + p.series.color + ';"><td><b>Ano ' + p.series.name + '</b></td><td>' + p.y + '</td></tr>'
                    } else {
                      strBefore += '<td style="padding:0 3px; color:' + p.series.color + ';"><b>Ano ' + p.series.name + '</b></td>'
                      str += '<tr style="color:' + p.series.color + ';"><td><b>Ano ' + p.series.name + '</b></td><td>' + p.y + '</td></tr>'
                    }
                  }
                  return p.series.name
                })
                str += '</table>'
                str += '<div style="height: 10px;"></div>'
                str += '<table border="1" width="100%" style="text-align: center;">'
                str += '<tr><td colspan="3"><b>SITUAÇÃO</b></td></tr>'
                str += '<tr><td></td><td style="padding:0 3px">Não aprovados</td><td style="padding:0 3px">Aprovados</td></tr>'
                _.each(this.points, (p) => {
                  if (p.series.type === 'column') {
                    if (p.series.name.indexOf('[current]') !== -1) {
                      strCurrent += '<td style="color:' + p.series.color + ';">' + p.y + '</td>'
                    } else {
                      strBefore += '<td style="color:' + p.series.color + ';">' + p.y + '</td>'
                    }
                  }
                  return p.series.name
                })
                strCurrent += '</tr>'
                strBefore += '</tr>'
                str += strCurrent
                str += strBefore
                str += '</table>'
                return str
              },
              */
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td><td style="padding:0">&nbsp;&nbsp;&nbsp;<b>{point.y}</b></td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
            },
            plotOptions: {
              column: {
                stacking: 'normal'
              }
            },
            // series: response.data,
            series: [
              {type: 'column', name: 'Em análise', stack: '2019', color: '#cbb956', data: response.data.analysis},
              {type: 'column', name: 'Reprovados', stack: '2019', color: '#bf262a', data: response.data.reproved},
              {type: 'column', name: 'Aprovados', stack: '2019', color: '#43A42C', data: response.data.approved},
              {type: 'line', name: 'Total', color: '#545457', data: response.data.total, marker: {lineWidth: 1}}
            ],
            credits: {
              style: {
                color: '#fff'
              }
            }
          }
        }, (error) => {
          console.log(error)
        })
      },
      ...mapActions(['loadRegistrationsByYears'])
    }
  }
</script>


// WEBPACK FOOTER //
// ChartRegistrationsByYears.vue?2cecef0c